import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'chapterVideo',
    component: () => import(/* webpackChunkName: "chapterVideo" */ '@/views/chapterVideo.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import(/* webpackChunkName: "demo" */ '@/views/demo/index.vue'),
  },
  {
    path: '/chapterVideo',
    name: 'chapterVideo',
    component: () => import(/* webpackChunkName: "chapterVideo" */ '@/views/chapterVideo.vue'),
  },
  {
    path: '/curseVideo',
    name: 'curseVideo',
    component: () => import(/* webpackChunkName: "curseVideo" */ '@/views/curseVideo.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;

